module.exports = __webpack_public_path__ + "static/media/dost_chatting.ee0bdcd4.gif";